import { Col, Row } from "antd";
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import useAxiosPost from "../../hooks/useAxiosPost";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";
import "./index.css";
import SMSBotRecentActivityTable from "../Items/Table/SMSBotRecentActivityTable";
const ViewSmsBotRecentActivity = () => {
  const [messages, setMessages] = useState<ITransactionMessage[]>([]);
  const { intPkSMSProbeID } = useParams();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>(
    "bots/getLastAcknowledgedMessagesBySomeSpecificProbe"
  );

  useEffect(() => {
    postApiData({ intPkSMSProbeID: Number(intPkSMSProbeID) });
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      setMessages(data || []);
    }
  }, [apiResponse]);

  if (apiLoading === true) {
    return <TailSpinLoader />;
  }

  return (
    <>
      <Row style={{ width: "100%" }}>
        <Col span={24}>
          <SMSBotRecentActivityTable messages={messages} />
        </Col>
      </Row>
    </>
  );
};
export default ViewSmsBotRecentActivity;
